import actionTypes from '../actions/actionTypes'
import http_request from 'sync/http_request'
import libraryTypes from 'helpers/enums/libraryTypes'
import { formatLibraryType } from 'helpers/libraryTypeFormatter'
import platformTypes from 'helpers/enums/platformTypes'
import viewTypes from 'helpers/enums/viewTypes'
import { setFlags } from 'helpers/featureFlags/provider'
import { appendTeamsScript, removeTeamsScript } from 'helpers/teamsScriptHandler'
import { assignHigherEdTranslations, localize } from 'helpers/translator/localize'
import cartDownloadProductSelector from 'redux/selectors/cart/cart_download_product_selector'
import academicLevelTypes from 'helpers/enums/academicLevelTypes'
import { IntercomAPI } from 'react-intercom'

function getClasses(element) {
	const classNames = element.getAttribute('class') || ''
	return classNames.split(' ')
}

function hideIntercom() {
	const body = document.getElementsByTagName('body')[0]
	const bodyClasses = getClasses(body)
	const intercomIndex = bodyClasses.indexOf('hide-intercom')
	if (intercomIndex === -1) {
		body.setAttribute('class', bodyClasses.join(' ') + ' hide-intercom')
	}

}

function showIntercom() {
	const body = document.getElementsByTagName('body')[0]
	const bodyClasses = getClasses(body)
	const intercomIndex = bodyClasses.indexOf('hide-intercom')
	if (intercomIndex !== -1) {
		bodyClasses.splice(intercomIndex, 1)
		body.setAttribute('class', bodyClasses.join(' '))
	}
}

function setExternalJwt(action) {
	if (action.params && action.params.jwt) {
		http_request.setExternalJWT(action.params.jwt)
	}
}

function setUserJwt(store, action) {
	if (action.payload && action.payload.jwt) {
		http_request.setJWT(action.payload.jwt)
		const storeState = store.getState()
		if (storeState.ui.platform === platformTypes.REACT_NATIVE) {
			http_request.alwaysSetUserJwt(true)
		}
	}
}

function handleHigherEdTranslations(action) {
	if (action.payload && action.payload.userAcademicLevel === academicLevelTypes.HIGHER_ED) {
		assignHigherEdTranslations()
	}
}

function handleLibraryInitialize(store) {
	const lti = store.getState().lti
	if (formatLibraryType(lti) !== libraryTypes.REGULAR) {
		hideIntercom()
	}
}

function addShownModals(store, action) {
	const user = store.getState().user
	action.shownModals = user.shownModals
}

function handleLaunchHomeworkInitialize() {
	appendTeamsScript()
}

function handleLaunchHomeworkUnmount() {
	removeTeamsScript()
}

function handleConctactUsInitialize() {
	showIntercom()
	IntercomAPI('showNewMessage')
}

// Retrocompatibility with OLD ANGULAR STORE, remove when ANGULAR AUTHORS PAGE get unused
function setCanUnselect(store, action) {
	action.canUnselect = [viewTypes.STORE_LANDING, viewTypes.STORE_SEARCH, viewTypes.STORE_FOLDER].includes(store.getState().ui.currentView)
}

function setExternalJwtFromAction(action) {
	if (action.jwt) {
		http_request.setExternalJWT(action.jwt)
	}
}

const handlePaywallsUpgradeSelected = (store, action) => {
	const state = store.getState()
	const cartData = cartDownloadProductSelector(state)
	if (!cartData.shouldOfferUpgrade && cartData.intercomIO && action.intercomIsEnabled) {
		IntercomAPI('showNewMessage', localize('cart_not_enough_space_intercom_message'))
	}
}

const generalMiddleware = store => next => action => {
	switch (action.type) {
		case actionTypes.LOGIN_INITIALIZE:
		case actionTypes.LOGIN_SSO_ERROR_CONFIRM_CONFIRMED:
		case actionTypes.SIGNUP_INITIALIZE:
			addShownModals(store, action)
			break
		case actionTypes.STUDENT_INITIALIZE_POLL:
		case actionTypes.STUDENT_INITIALIZE_QUIZ:
		case actionTypes.STUDENT_INITIALIZE_OEQ:
		case actionTypes.STUDENT_INITIALIZE_DRAW_IT:
		case actionTypes.STUDENT_INITIALIZE_READ_ONLY:
		case actionTypes.MATCHING_PAIRS_STUDENT_INITIALIZE:
		case actionTypes.STUDENT_INITIALIZE_LEAD:
			setFlags(action.session.featureFlags)
			break
		case actionTypes.INTERACTIVE_VIDEO_STANDALONE_INITIALIZE:
		case actionTypes.FEATURE_FLAGS_GET_SUCCESS:
			setFlags(action.featureFlags)
			break
		case actionTypes.STORE_FILTER_SELECTED:
			setCanUnselect(store, action)
			break
		case actionTypes.USER_DATA_FETCHED:
			handleHigherEdTranslations(action)
			break
	}
	next(action)
	switch (action.type) {
		case actionTypes.STOREFRONT_FINALIZE:
		case actionTypes.INTERACTIVE_VIDEO_PREVIEW_SESSION_EXIT:
			showIntercom()
			break
		case actionTypes.STOREFRONT_OWNER_INITIALIZE:
		case actionTypes.STOREFRONT_VISITOR_INITIALIZE:
		case actionTypes.STOREFRONT_INITIALIZE_PREVIEW:
		case actionTypes.PRIVATE_LIBRARY_LAUNCH_VIDEO_PREVIEW:
		case actionTypes.MY_LIBRARY_LAUNCH_VIDEO_PREVIEW:
		case actionTypes.STORE_LAUNCH_VIDEO_PREVIEW:
			hideIntercom()
			break
		case actionTypes.USER_IS_LOGGED:
		case actionTypes.USER_DATA_FETCHED:
			setUserJwt(store, action)
			break
		case actionTypes.GAME_INITIALIZE_CREATION_TOOL:
		case actionTypes.GAME_UPDATE_CREATION_TOOL:
		case actionTypes.GAME_INITIALIZE_STANDALONE:
		case actionTypes.FLIPGRID_CREATION_TOOL_INITIALIZE:
		case actionTypes.FLIPGRID_INITIALIZE_STANDALONE:
			setExternalJwt(action)
			break
		case actionTypes.INTERACTIVE_VIDEO_INITIALIZE_CREATION_TOOL:
		case actionTypes.VIDEO_INITIALIZE_PICKER_ROUTE:
		case actionTypes.VIDEO_INITIALIZE_EDIT_ROUTE:
		case actionTypes.INTERACTIVE_VIDEO_INITIALIZE_CREATION_TOOL_EDIT:
		case actionTypes.VIDEO_STANDALONE_INITIALIZE_PICKER_ROUTE:
		case actionTypes.VIDEO_STANDALONE_INITIALIZE_EDIT_ROUTE:
		case actionTypes.WHITEBOARD_MOUNTED:
		case actionTypes.WHITEBOARD_UPDATED:
			setExternalJwtFromAction(action)
			break
		case actionTypes.MY_LIBRARY_INITIALIZE:
			handleLibraryInitialize(store)
			break
		case actionTypes.MY_LIBRARY_LAUNCH_HOMEWORK_INITIALIZE:
			handleLaunchHomeworkInitialize()
			break
		case actionTypes.MY_LIBRARY_LAUNCH_HOMEWORK_UNMOUNT:
			handleLaunchHomeworkUnmount()
			break
		case actionTypes.NAVIGATION_MENU_HELP_CONTACT_US_SELECTED:
			handleConctactUsInitialize()
			break
		case actionTypes.PAYWALLS_NOT_ENOUGH_SPACE_CONFIRM_UPGRADE_SELECTED:
			handlePaywallsUpgradeSelected(store, action)
			break
	}

}

export default generalMiddleware
